import { render, staticRenderFns } from "./CollapsableEncapsulator.vue?vue&type=template&id=304d1e68&scoped=true"
import script from "./CollapsableEncapsulator.vue?vue&type=script&lang=js"
export * from "./CollapsableEncapsulator.vue?vue&type=script&lang=js"
import style0 from "./CollapsableEncapsulator.vue?vue&type=style&index=0&id=304d1e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d1e68",
  null
  
)

export default component.exports